import { get } from 'lodash';
import { mapGetters } from 'vuex';
import cmsPlaceholder from 'vue/mixins/cms/cms-placeholder';


export default {
    mixins: [
        cmsPlaceholder,
    ],
    props: {
        partial: String,
    },
    computed: {
        ...mapGetters(['partials']),
        showPartial() {
            const partials = get(this.$route, 'meta.api.query.partials', []);
            return partials.includes(this.partial);
        },
    },
};



// WEBPACK FOOTER //
// ./sib-website/assets/src/js/app/vue/mixins/cms/cms-partial/index.js